import { Application } from "../config";
import { images } from "../images";
import { DocumentType } from "../models/document-type";
import { ICancelBookingReasons } from "../models/cancel-booking-reasons";

const { isNemi, isAmb, isIframe } = Application

const appsStyle = [
    { name: 'Nemi', style: 'nemi', selected: isNemi },
    { name: 'AMB', style: 'amb', selected: isAmb },
    { name: 'Iframe', style: 'iframe', selected: isIframe }
]

const appsGeneralInfo = [
    { name: 'Nemi', id: 'Nemi', title: 'Nemi Your digital partner', copyright: '© Nemi', selected: isNemi },
    { name: 'AMB', id: 'AMB', title: 'Àrea Metropolitana de Barcelona', copyright: '© Àrea Metropolitana de Barcelona', selected: isAmb },
    { name: 'Iframe', id: 'Iframe', title: 'Iframe', copyright: '© Iframe', selected: isIframe },
]

const appsURLS = [
    { name: 'Nemi', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', selected: isNemi },
    { name: 'AMB', home: 'http://www.amb.cat/s/home.html', contact: 'http://www.amb.cat/web/amb/seu-electronica/suggeriments-i-queixes', linkedin: 'https://www.linkedin.com/cws/share?url=http://www.amb.cat/guia-estils', twitter: '', selected: isAmb },
    { name: 'Iframe', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', selected: isIframe },
]

const appsLogos = [
    { name: 'Nemi', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isNemi },
    { name: 'AMB', logo: images['logoWhite'],logoRounded: images['logoAmb'], alt: 'AMB:Bus Metropolità', class: 'logo', classRounded: 'logoAmb', selected: isAmb },
    { name: 'Iframe', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isIframe },
]

const appsPrivacyAndTermsOptions = [
    { name: 'Nemi', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'Nemi Mobility Solutions SL', someLanguages: true, selected: isNemi },
    { name: 'AMB', privacy: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', terms: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', owner: null, someLanguages: false, selected: isAmb },
    { name: 'Iframe', privacy: `https://www.divertisenvivo.com/politica-privacidad-venta-online`, terms: `https://www.divertisenvivo.com/terminos-y-condiciones/`, owner: 'Divertis en vivo', someLanguages: false, selected: isIframe },
]

const appsShowRefundsSection = [
    { name: 'Nemi', show: false, selected: isNemi },
    { name: 'AMB', show: false, selected: isAmb },
    { name: 'Iframe', show: false, selected: isIframe },
]

const appsLogin = [
    { name: 'Nemi', login: ['email'], selected: isNemi },
    { name: 'AMB', login: ['dni', 'email'], selected: isAmb },
    { name: 'Iframe', login: ['email'], selected: isIframe },
]

const appsUsername = [
    { name: 'Nemi', username: 'email', selected: isNemi },
    { name: 'AMB', username: 'dni', selected: isAmb },
    { name: 'Iframe', username: 'email', selected: isIframe },
]

const appsRecoverPassword = [
    { name: 'Nemi', username: 'email', selected: isNemi },
    { name: 'AMB', username: 'dni', selected: isAmb },
    { name: 'Iframe', username: 'email', selected: isIframe },
]

// Extra sign-up fields to show, beyond name/lastName/dni/email (already handled
// separately). Empty for every brand nemi-web currently serves — ready for a
// future brand to opt in without touching Nemi/AMB/Iframe.
const appsRegister = [
    { name: 'Nemi', data: [] as string[], selected: isNemi },
    { name: 'AMB', data: [] as string[], selected: isAmb },
    { name: 'Iframe', data: [] as string[], selected: isIframe },
]

// Document upload requirement, mirrored from mobile's appsDocument config.
// Disabled (requireDocumentation: false) for every brand nemi-web currently
// serves — built ready but inactive, same pattern as the other Fase 2 items.
const appsDocument = [
    { name: 'Nemi', documentType: [DocumentType.ID_CARD, DocumentType.HEALTH_CARD], mandatory: true, selected: isNemi, requireDocumentation: false },
    { name: 'AMB', documentType: [DocumentType.ID_CARD, DocumentType.PASSPORT], mandatory: true, selected: isAmb, requireDocumentation: false },
    { name: 'Iframe', documentType: [DocumentType.ID_CARD, DocumentType.PASSPORT], mandatory: true, selected: isIframe, requireDocumentation: false },
]

// Temporal passes (wallet), mirrored from mobile's appsTemporalPasses config.
// Disabled for every brand — mobile ships it disabled everywhere too, so the
// wallet is built ready but inactive until a brand opts in.
const appsTemporalPasses = [
    { name: 'Nemi', enabled: false, selected: isNemi },
    { name: 'AMB', enabled: false, selected: isAmb },
    { name: 'Iframe', enabled: false, selected: isIframe },
]

// Cancellation reason asked when deleting a booking. With `reasons` the modal offers a
// picker of those values; without it, a free text field. Mirrors the app, where every
// brand nemi-web serves goes without a list and without making it mandatory.
const appsCancelBookingReasons = [
    { name: 'Nemi', reasons: null as typeof ICancelBookingReasons | null, selected: isNemi },
    { name: 'AMB', reasons: null as typeof ICancelBookingReasons | null, selected: isAmb },
    { name: 'Iframe', reasons: null as typeof ICancelBookingReasons | null, selected: isIframe },
]

const appsMandatoryCancellationReason = [
    { name: 'Nemi', mandatory: false, selected: isNemi },
    { name: 'AMB', mandatory: false, selected: isAmb },
    { name: 'Iframe', mandatory: false, selected: isIframe },
]

// Penalties section: whether the brand shows it at all. The app has no config for this —
// it derives the tab from the brand (everyone but AMB) — so here it is explicit and
// independent of the wallet, which the app made share the same tab slot.
const appsPenalties = [
    { name: 'Nemi', enabled: false, selected: isNemi },
    { name: 'AMB', enabled: false, selected: isAmb },
    { name: 'Iframe', enabled: false, selected: isIframe },
]

// Scheduled (recurring) bookings, mirrored from mobile's appsScheduled config.
// Disabled for every brand — mobile ships it disabled everywhere too.
const appsScheduled = [
    { name: 'Nemi', scheduled: false, selected: isNemi },
    { name: 'AMB', scheduled: false, selected: isAmb },
    { name: 'Iframe', scheduled: false, selected: isIframe },
]

const appsLanguagePosition = [
    { name: 'Nemi', languages: [ 'en', 'es', 'ca', 'eu', 'pt', 'fr', 'de', 'it', 'nl', 'hu', 'si', 'hr', 'el' ], selected: isNemi },
    { name: 'AMB', languages: [ 'ca', 'es', 'en' ], selected: isAmb },
    { name: 'Iframe', languages: [ 'en', 'es', 'ca', 'eu', 'pt', 'fr', 'de', 'it', 'nl', 'hu', 'si', 'hr', 'el' ], selected: isIframe },
]

export const appsStyleSelected = appsStyle.find(app => app.selected)

export const appsGeneralInfoSelected = appsGeneralInfo.find(app => app.selected)

export const appsURLSSelected = appsURLS.find(app => app.selected)

export const appsLogosSelected = appsLogos.find(app => app.selected)

export const appsPrivacyAndTermsOptionsSelected = appsPrivacyAndTermsOptions.find(app => app.selected)

export const appsShowRefundsSectionSelected = appsShowRefundsSection.find(app => app.selected)

export const appsLanguagePositionSelected = appsLanguagePosition.find(app => app.selected)

export const appsLoginSelected = appsLogin.find(app => app.selected)

export const appsUsernameSelected = appsUsername.find(app => app.selected)

export const appsRecoverPasswordSelected = appsRecoverPassword.find(app => app.selected)

export const appsRegisterSelected = appsRegister.find(app => app.selected)

export const appsDocumentSelected = appsDocument.find(app => app.selected)

export const appsTemporalPassesSelected = appsTemporalPasses.find(app => app.selected)

export const appsScheduledSelected = appsScheduled.find(app => app.selected)

export const appsPenaltiesSelected = appsPenalties.find(app => app.selected)

export const appsCancelBookingReasonsSelected = appsCancelBookingReasons.find(app => app.selected)

export const appsMandatoryCancellationReasonSelected = appsMandatoryCancellationReason.find(app => app.selected)